import { useLocation } from "react-router-dom";

function Header({ contextValue }) {
	const { isAuth, authUser, onLogout } = contextValue;
	const location = useLocation();
	const userMenuButtonId = "user-menu-button";
	const userMenuId = "user-menu";

	const canISeeUserInfo = () => {
		const paths = ["", "/tickets", "/ticket-office", "/ticket-office/login-app", "/tickets/login-app"];

		const trimmedPathname = location.pathname.replace(/\/+$/, "");

		if (isAuth && paths.includes(trimmedPathname)) {
			return false;
		}

		if (!isAuth) {
			return false;
		}

		return true;
	};

	return (
		<header className="container-fluid header p-3">
			<a
				className="skip-link"
				href="#main-content"
				aria-label="Μετάβαση στο κύριο περιεχόμενο"
			>
				Κύριο περιεχόμενο
			</a>
			<div className="d-flex flex-wrap">
				<div className="p-2 text-sm-center">
					<a
						className="header-logo-link"
						href="https://www.gov.gr/"
						aria-label="Μετάβαση στην αρχική σελίδα του gov.gr"
					>
						<div className="logo">
							<img src="/img/gov_gr_logo.svg" alt="" width="140" />
						</div>
					</a>
				</div>
				<div className="p-2 text-sm-center border-left">
					<h2 className="header-title mb-0">Πλατφόρμα διαχείρισης αθλητικών εισιτηρίων</h2>
				</div>
				{canISeeUserInfo() && (
					<div className="text-sm-center dropdown user ms-auto p-2">
						<button
							className="btn btn-secondary dropdown-toggle"
							type="button"
							id={userMenuButtonId}
							data-bs-toggle="dropdown"
							aria-expanded="false"
							aria-haspopup="menu"
							aria-controls={userMenuId}
						>
							{`${authUser?.firstname} ${authUser?.lastname}`}
						</button>
						<ul className="dropdown-menu" id={userMenuId} aria-labelledby={userMenuButtonId}>
							<li>
								<button type="button" className="dropdown-item" onClick={onLogout}>
									Έξοδος
								</button>
							</li>
						</ul>
					</div>
				)}
			</div>
		</header>
	);
}

export default Header;
